import React, {PureComponent} from 'react';

import Register from './Register.jsx';

import conf from '../../../shared/conf.js';

export default class RegisterAsDo extends PureComponent {
  render() {
    return <Register
      accountType={conf.accountTypes.do}
      metaDescription="Renseignez les informations de votre structure en quelques : vous pourrez ensuite consulter les différents profils disponibles et déposer une annonce"
      metaTitle="Créez un profil pour votre organisation"
    />;
  }
}
